import { showcaseWrapper } from '@beeline/lk-utils';

import { enableMapSet } from 'immer';
import { createRoot } from 'react-dom/client';

import ':styles/themes.scss';
import '@beeline/design-tokens/css/tokens/globals/index.css';
import '@beeline/design-tokens/css/font-face.css';
import '@beeline/design-tokens/css/iconfont/iconfont.css';
import '@beeline/design-system-react/extracted-styles/esm/index.css';

import { Service } from './Service';
import { modules } from './modules';

enableMapSet();

showcaseWrapper(modules, () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');

  rootElement.style.height = '100dvh';

  const root = createRoot(rootElement);
  root.render(<Service />);
});
